import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width="22pt" height={32} viewBox="0 0 22 24" {...props}>
      <Path
        d="M24.263 27.262V.738L6.618 14zM.737.738v26.524"
        transform="scale(.88 .85714)"
        fill="none"
        strokeLinecap="square"
        stroke="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
